import React, { useCallback, useEffect, useMemo } from 'react'
import { Menu, MenuItem, Container, ToolBar, SegmentedButton, Tooltip, Button, Spacer, Label, Panel } from '@sencha/ext-modern'

import { useDelayTimer, useInstData } from 'tyan/public/hooks'
import { reconfigButton } from 'tyan/public/utility'
import { renderFiltersButton } from 'tyan/public/components/column'

import SearchField from './SearchField'
import PageSelect from './PageSelect'

const DesktopToolbar = props => {
	const {
		calcThat,
		config, columnConfig, tabs, searchValue, handleSearchFieldChange, pathname, tabName, handleTabChange, tabCounts, handleExport, handlePivot, handleShow,
		total, list, beginNum, endNum, pageNum, minPage, maxPage, onPageSelected, onChgNumPerPage,
		handleToolbarButton,
		sumFields, sumValues,
	} = props

	const { me } = useInstData(props, useMemo(() => ({ containers: [[], [], []] }), []))

	const { doDelay } = useDelayTimer(200)

	const rearrangeToolbar = useCallback(() => {
		const doRearrange = () => {
			// window.me = me
			const { toolbar, search, containers } = me
			let remain = toolbar.el.dom.clientWidth
				- search.el.dom.clientWidth
				- containers.reduce((sum, o) => sum + (o[0] ? o[0].bodyElement.dom.scrollWidth : 0), 0)

			let step = 0
			while (remain < 0 && step < 3) {
				const arr = containers[step++]
				remain += (arr[0] ? arr[0].bodyElement.dom.scrollWidth : 0) - (arr[1] ? arr[1].bodyElement.dom.scrollWidth : 0)
			}

			containers.forEach((container, index) => {
				step > index
					? (container[0] && container[0].setWidth(0), container[1] && container[1].setWidth('auto'))
					: (container[0] && container[0].setWidth('auto'), container[1] && container[1].setWidth(0))
			})
		}

		doDelay(doRearrange)
	}, [])

	useEffect(() => { rearrangeToolbar() })

	const [SubComp, subCompProps, btnProps] = useMemo(() => (
		[Menu, { padding: 8, align: 't50-b50', anchor: true }, {}]
		// Ext.platformTags.touch
		// 	? [Menu, { padding: 8 }, {}]
		// 	: [Tooltip, { allowOver: true, showDelay: 100, dismissDelay: 0, align: 't-b', anchor: true }, { iconAlign: 'right', iconCls: 'x-fa fa-caret-down' }]
	), [Ext.platformTags.touch])

	// 呈现导出及分析按钮
	const renderExportOrPivot = ({ text, handler, icon, conf, Item, itemProps, index }) => {
		const keys = Object.keys(conf)
		let menu

		const itemHandler = item => {
			if (Item === MenuItem) {
				menu.parentMenu.isHidden()
					? handler(item.value)
					: setTimeout(() => itemHandler(item))
			} else {
				handler(item.value)
			}
		}
		return <Item ref={ref => ref && (menu = ref.cmp)} {...itemProps}
			{...{
				iconCls: `x-fa fa-${icon}`, ui: 'action',
				text: keys.length == 1 ? `${text} ...` : keys.length < 1 ? `${text} Err` : text,
				disabled: !total,
				handler: keys.length == 1 ? () => handler(keys[0]) : null,
				menu: keys.length > 1
					? {
						defaults: { handler: itemHandler },
						anchor: !index,
						items: keys.map(n => ({ text: Tyan.t(n, 'button'), value: n, ui: 'action' }))
					}
					: undefined
			}}
		/>
	}

	const renderCommands = () => {
		let btnsCount = 0

		const commands = [
			[Container, { padding: '8 8 8 18', margin: 0 }, Button, { margin: "0 10 0 0", shadow: true, style: { padding: '0px' } }],
			[Menu, { anchor: true, align: 'tr-br' }, MenuItem, {}]
		]
			.map(([Wrapper, wrapperProps, Item, itemProps], index) => (
				<Wrapper {...wrapperProps}>
					{(config.buttons || [])
						.map((o, i) => {
							const { icon, text, disabled = false, ui = 'action', align = 'left', cdt } = reconfigButton(o)
							return (!cdt || calcThat(cdt))
								? (btnsCount++, <Item key={i}	{...itemProps}{...{
									iconCls: icon && `x-fa fa-${icon}`, text: index ? Tyan.t(text, 'button') : text, align, ui,
									handler: () => handleToolbarButton(o),
									disabled: calcThat(disabled)
								}} />)
								: null
						})
					}
					{config.export
						? (btnsCount++,
							renderExportOrPivot({
								text: index ? Tyan.t('导出', 'button') : '导出',
								icon: 'download', handler: handleExport, conf: config.export, Item, itemProps, index
							})
						)
						: null
					}
					{config.pivot
						? (
							btnsCount++,
							renderExportOrPivot({
								text: index ? Tyan.t('分析', 'button') : '分析',
								icon: 'bar-chart-o', handler: handlePivot, conf: config.pivot.views, Item, itemProps, index
							})
						)
						: null
					}
					{
						config.show
							? (btnsCount++, <Item {...itemProps}{...{ iconCls: 'x-fa fa-desktop', text: Tyan.t('投屏 ...', 'button'), ui: "action", handler: handleShow, disabled: !total }} />)
							: null
					}

				</Wrapper >
			))

		return <>
			{[0, 1].map(index => {
				const inner = !index || btnsCount <= 1
					? commands[0]
					: <Button margin="0 10 0 0" shadow ui='action' /* iconCls={icon && `x-fa fa-${icon}`}  */ text='操作' >
						{commands[1]}
					</Button>

				return <Container key={index} ref={ref => ref && (me.containers[2][index] = ref.cmp)} layout={{ type: 'hbox', align: 'center' }} height='100%'
					{...index ? { width: '0' } : {}}
				>
					{inner}
				</Container>
			})}
		</>
	}

	const renderTabs = () => {
		const tabComps = tabs && Object.keys(tabs).length &&
			<SegmentedButton defaultUI="toolbar-default" value={tabName} onChange={handleTabChange} margin="0 10 0 0">
				{Object.entries(tabs).map(([tn, config]) => <Button
					noLocale key={tn} value={tn}
					text={Tyan.t(tn, 'tab') + (tabCounts && tabCounts[tn] && `(${tabCounts[tn]})` || '')}
					tooltip={config.title} style={{ padding: 0 }}
				/>)}
			</SegmentedButton> || null

		return <>
			{[0, 1].map(index => {
				const inner = (!tabComps || !index)
					? tabComps
					: <SegmentedButton defaultUI="toolbar-default" value='tabs' margin="0 10 0 0">
						<Button noLocale value='tabs'
							text={`${Tyan.t(tabName, 'tab')}${tabCounts && tabCounts[tabName] && `(${tabCounts[tabName]})` || ''}`}
							{...btnProps}
						>
							<SubComp {...subCompProps} >
								{tabComps}
							</SubComp>
						</Button>
					</SegmentedButton>
				return <Container key={index} ref={ref => ref && (me.containers[1][index] = ref.cmp)} layout={{ type: 'hbox', align: 'center' }} height='100%'
					{...index ? { width: '0' } : {}}
				>
					{inner}
				</Container>
			})}
		</>
	}

	const renderPageInfo = () => {
		// 组织Sum信息
		const sumInfo = sumFields && sumValues
			&& sumFields.length && sumFields.length === sumValues.length
			&& sumFields.map(({ prefix, suffix, rate, decimal, thousand, displayFn }, index) => {
				if (displayFn) return displayFn(sumValues[index])
				let v = (sumValues[index] * rate).toFixed(decimal)
				thousand && (v = v.replace(/(\d)(?=(\d{3})+\.)/g, '$1,'))
				return `${prefix} ${v} ${suffix};`
			}).join()

		return <>
			{[0, 1].map(index => (
				<Container key={index} ref={ref => ref && (me.containers[0][index] = ref.cmp)} layout={{ type: 'hbox', align: 'center' }} height='100%' padding='0 10 0 0'
					{...index ? { width: '0' } : {}}
				>
					<Panel padding="2 2 2 10" shadow layout={{ type: 'hbox', align: 'center' }} margin='0 0 0 10' style={{ 'border-radius': '3px' }} /* right={10} */>
						{sumInfo && <Label margin='0 5 0 0' noLocale html={`<div>${sumInfo}</div>`} /> || null}
						<Label noLocale html={index
							? `<div>${total ? `${list ? list.length : 0} (${beginNum} ~ ${endNum}) / ${total} ` : `0 `}${Tyan.t('条记录', 'pub')}&nbsp;&nbsp;</div>`
							: `<div>${Tyan.t('ManagerPageInfo', 'pub', { total, length: list ? list.length : 0, beginNum, endNum })}</div>`
						} />
						<Button iconCls="x-fa fa-angle-left" text={index ? '' : '上一页'} handler={() => onPageSelected(pageNum - 1)} disabled={!pageNum || pageNum <= minPage} padding='0' />
						<Button noLocale align="right" text={Tyan.t('第m/n页', 'pub', { pageNum, totalPageNum: maxPage })} menuAlign="tr-br" /* margin="0 5 0 5"  */>
							<PageSelect {...{ minPage, maxPage, pageNum, onPageSelected, onChgNumPerPage, pathname, tabName }} />
						</Button>
						<Button iconAlign="right" iconCls="x-fa fa-angle-right" text={index ? '' : '下一页'} handler={() => onPageSelected(pageNum + 1)} disabled={pageNum >= maxPage} />
					</Panel>
				</Container>
			))}
		</>
	}

	return <ToolBar ref={ref => ref && (me.toolbar = ref.cmp)} onResize={rearrangeToolbar}
		docked="top" ui="app-transparent-toolbar" shadow={false} margin="0 0 0 10" padding="0" layout={{ type: 'hbox', align: 'center' }}
	>
		<Container ref={ref => ref && (me.search = ref.cmp)} layout={{ type: 'hbox', align: 'center' }} height='100%'>
			<SearchField value={searchValue} onChange={handleSearchFieldChange} scannable={config && config.searchFieldScannable} />
			{renderFiltersButton({ columns: config.columns, ...columnConfig })}
		</Container>
		{renderTabs()}
		{renderCommands()}
		<Spacer />
		{renderPageInfo()}
	</ToolBar >
}

export default DesktopToolbar